var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"},attrs:{"id":_vm.openid}},[_c('ww-open-data',{attrs:{"type":_vm.type,"openid":_vm.openid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }